import fetchApi from "../fetchApi";

export const ToggleRoleActive = async (id) => {
  const options = {
    method: "PUT",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
    body: JSON.stringify({}),
    redirect: "follow",
  };

  return await fetchApi(`roles/${id}/toggle-active`, options);
};
